import { render } from "./loginCom.vue?vue&type=template&id=00322720&scoped=true"
import script from "./loginCom.vue?vue&type=script&lang=js"
export * from "./loginCom.vue?vue&type=script&lang=js"

import "./loginCom.vue?vue&type=style&index=0&id=00322720&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00322720"]])

export default __exports__